import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { BiddersForTable } from '../../types'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_WORKSPACE_BIDDERS } from './api/query'
import { BiddersForTableDTO } from './api/types'
import { UseGetBidders, UseGetBiddersProps } from './types'

export const useGetBidders = ({
  filters,
  first,
  last,
  sort,
}: UseGetBiddersProps): UseGetBidders => {
  const { workspaceId } = useWorkspaceParam()
  const [bidders, setBidders] = useState<BiddersForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { loading } = useQuery(GET_WORKSPACE_BIDDERS, {
    onCompleted: ({ workspaceBidders: { nodes: bidders, totalCount: count } }): void => {
      if (bidders) {
        setBidders(bidders.map((bidder: BiddersForTableDTO): BiddersForTable => fromDTO(bidder)))
        setCount(count)
      }
    },
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return { bidders, count, loading }
}
